import {
  EXPORT_LEGAL_ENTITIES,
  LEGAL_TABLE_FRAGMENT,
  LEGAL_TABLE_NAMES,
  LEGAL_TABLE_QUERY,
  SYNCRONIZE_LEGAL_ENTITIES
} from "./legal-entities/legal-entities.operation";
import { LegalEntityFilters } from "../../shared/models/legal-entity.model";
import {
  CPT_TABLE_FRAGMENT,
  CPT_TABLE_NAMES,
  CPT_TABLE_QUERY,
  EXPORT_CPTS,
  GET_CPT_TABLE,
  SYNCRONIZE_CPTS
} from "./cpt/cpt.operation";
import { UsersFilters } from "../models/user.model";
import { FilterResult } from "../../features/administration/legal-entities/legal-entities.component";
import { CptsFilters } from "../models/cpt.model";
import {
  CREATE_QUESTION,
  CREATE_SECTION,
  DELETE_QUESTION,
  DELETE_SECTION,
  QUALITATIVE_TABLE_FRAGMENT,
  QUALITATIVE_TABLE_QUERY,
  UPDATE_QUESTION
} from "./qualitative/qualitative.operation";
import { RisksFilters } from "../models/risk.model";
import {
  EXPORT_RISKS,
  GET_RISK_TABLE,
  RISK_TABLE_NAMES,
  RISK_TABLE_QUERY,
  SYNCRONIZE_RISKS
} from "./risk/risk.operation";
import { PagingInput, RiskQueryComplexInput, RiskSortInput } from "../../../../graphql/generated";

const LegalEntitiesQL = {
  fragments: {
    table: LEGAL_TABLE_FRAGMENT
  },
  queries: {
    table_with_filters: (filters: LegalEntityFilters, search: string, manageScope: boolean) =>
      LEGAL_TABLE_QUERY(filters, search, manageScope),
    names: LEGAL_TABLE_NAMES(
      "auditControlApproach",
      "businessType",
      "category",
      "chiefAuditor",
      "endDate",
      "lastTaxonomyCampaignCompletionDate",
      "lastTaxonomyCampaignStartingDate",
      "startDate",
      "valueChain",
      "lastUpdated",
      "legalEntityTrackingId",
      "businessUnit",
      "organizationalUnit",
      "id",
      "legalEntityCode",
      "legalEntityName",
      "legalEntitySize",
      "macroBusinessUnit",
      "status",
      "currentCampaign"
    )
  },
  mutation: {
    exportLegalEntities: EXPORT_LEGAL_ENTITIES,
    syncronize: SYNCRONIZE_LEGAL_ENTITIES
  }
};

const QualitativeQL = {
  fragments: {
    table: QUALITATIVE_TABLE_FRAGMENT
  },
  queries: {
    table: QUALITATIVE_TABLE_QUERY
  },
  mutations: {
    createMacroSection: CREATE_SECTION,
    createQuestion: CREATE_QUESTION,
    deleteSection: DELETE_SECTION,
    deleteQuestion: DELETE_QUESTION,
    updateQuestion: UPDATE_QUESTION
  }
};

const CPTQl = {
  fragments: {
    table: LEGAL_TABLE_FRAGMENT
  },
  queries: {
    get: GET_CPT_TABLE
  }
};

const CptQL = {
  fragments: {
    table: CPT_TABLE_FRAGMENT
  },
  queries: {
    table_with_filters: (filters: CptsFilters, search: string) =>
      CPT_TABLE_QUERY(filters, search),
    names: CPT_TABLE_NAMES(
      "auditDomain",
      "auditSubdomain",
      "cluster",
      "code",
      "id",
      "internalAuditDomain",
      "name",
      "valueChain",
      "processStatus"
    ),
    get: GET_CPT_TABLE
  },
  mutation: {
    exportCpts: EXPORT_CPTS,
    syncronize: SYNCRONIZE_CPTS
  }
};

const RiskQL = {
  fragments: {
    table: CPT_TABLE_FRAGMENT
  },
  queries: {
    table_with_filters: (
      page: PagingInput,
      query: RiskQueryComplexInput,
      sort: RiskSortInput,
      search?: string
    ) =>
      RISK_TABLE_QUERY(page, query, sort, search),
    names: RISK_TABLE_NAMES(
      "riskCode",
      "riskName",
      "riskStatus",
      "riskDescription",
      "category"
    ),
    get: GET_RISK_TABLE
  },
  mutation: {
    exportRisks: EXPORT_RISKS,
    syncronize: SYNCRONIZE_RISKS
  }
};

const RiskMapQL = {

  mutation: {
  }
};

export { LegalEntitiesQL, CPTQl, CptQL, RiskQL, QualitativeQL, RiskMapQL };

export function buildStringSchema(filters: GraphFilter, fields_const: any) {
  let result = "";

  Object.entries(filters).map(
    (filter) =>
    (result +=
      fields_const[filter[0]] !== undefined &&
        (filter[1] !== null ||
          ((filter[1] as any)?.valueArray !== null &&
            (filter[1] as any)?.valueArray?.length > 0))
        ? `
        { field: ${fields_const[filter[0]]
        }, filters: { value : ${JSON.stringify(
          foundFilterValues(filter[1])
        )}, operator: ${foundFilterOperator(filter[1])} } }`
        : "")
  );
  return result;
}

export function foundFilterValues(
  filterValue: ((FilterResult & (string | number | Date)) | any)[]
) {
  return filterValue instanceof Array
    ? filterValue.map(f => f?.toString() ?? '')
    : (filterValue as any).valueArray?.toString() ?? '';
}

export function foundFilterOperator(filterValue: any) {
  return filterValue.operator ?? "MATCH";
}

export function buildSearchSchema(
  search: string | undefined,
  fields: string[]
): string[] | undefined {
  return search
    ? fields.map(field => `{ field: ${field} , filters: { value: "${search}", operator: CONTAINS } }`)
    : undefined;
}

export type GraphFilter =
  | LegalEntityFilters
  | UsersFilters
  | CptsFilters
  | RisksFilters;